import axios from 'axios';

// Simple frontend logging: axios interceptors + global error handlers
// Note: Avoid sending PII. Logs are for diagnostics only.

let requestCounter = 0;

export function installFrontendLogging() {
  // Axios request interceptor
  axios.interceptors.request.use((config) => {
    const id = (++requestCounter).toString();
    const meta = { id, ts: Date.now(), method: config.method, url: config.url };
    config.headers['X-Client-Request-ID'] = id;
    console.debug('[HTTP][REQ]', meta);
    config.metadata = meta;
    return config;
  }, (error) => {
    console.error('[HTTP][REQ][ERR]', error?.message);
    return Promise.reject(error);
  });

  // Axios response interceptor
  axios.interceptors.response.use((response) => {
    const meta = response.config?.metadata || {};
    meta.ms = Date.now() - (meta.ts || Date.now());
    const reqId = response.headers['x-request-id'] || response.headers['X-Request-ID'];
    console.debug('[HTTP][RES]', { ...meta, status: response.status, reqId });
    return response;
  }, (error) => {
    const cfg = error.config || {};
    const meta = cfg.metadata || {};
    meta.ms = Date.now() - (meta.ts || Date.now());
    const res = error.response || {};
    const reqId = (res.headers && (res.headers['x-request-id'] || res.headers['X-Request-ID'])) || 'n/a';
    console.error('[HTTP][RES][ERR]', { ...meta, status: res.status, reqId, message: error.message });
    return Promise.reject(error);
  });

  // Global error handling
  window.onerror = function(message, source, lineno, colno, error) {
    console.error('[GLOBAL][ONERROR]', { message, source, lineno, colno, stack: error?.stack });
  };

  window.onunhandledrejection = function(event) {
    console.error('[GLOBAL][UNHANDLED_REJECTION]', { reason: event?.reason?.message || String(event.reason) });
  };
}
